// extracted by mini-css-extract-plugin
module.exports = {"qrCodeWithDownload":"QrCodeWithDownload_qrCodeWithDownload__Cpatp","qrCodeWithDownload__downloadLink":"QrCodeWithDownload_qrCodeWithDownload__downloadLink__3t1ES"};